/* eslint-disable check-file/filename-blocklist */
import { Box, Flex } from '@chakra-ui/react';
import { Formik, Form, FieldArray } from 'formik';
import { ScoreCardContainer } from './components/ScoreCardContainer';
import {
  DragDropContext,
  Droppable,
} from '@atlaskit/pragmatic-drag-and-drop-react-beautiful-dnd-migration';
import { FormikOnChangeObserver } from '../formBuilder/components';
import { Feedback } from '@/components/score-card-builder/Feedback';
import { OverallEvaluation } from '@/components/score-card-builder/OverallEvaluation';
import { scoreCardValidationSchema } from './validationSchema';
export const ScoreCardBuilder = ({
  formRef,
  initialValues = {},
  onSubmit = () => {},
  observFunc = () => {},
}) => {
  const onDragEnd = (result) => {
    if (!result.destination) return;
    const startIndex = result.source.index;
    const endIndex = result.destination.index;
    const scoreCardsArr = Array.from(
      formRef?.current?.values?.scoreCards ?? []
    );
    const currentValues = formRef?.current?.values || {};
    const [removed] = scoreCardsArr.splice(startIndex, 1);
    scoreCardsArr.splice(endIndex, 0, removed);
    formRef?.current?.setValues({
      ...currentValues,
      scoreCards: scoreCardsArr,
    });
  };
  return (
    <Formik
      innerRef={formRef}
      initialValues={initialValues}
      validationSchema={scoreCardValidationSchema}
      onSubmit={onSubmit}
      validateOnBlur={true}
      validateOnChange={false}
    >
      {(formik) => (
        <Form>
          <Flex flexDir="column" gap="12px">
            <DragDropContext onDragEnd={onDragEnd}>
              <Droppable droppableId="score-card-droppable">
                {(provided) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                    style={{
                      flex: 1,
                      gap: '6px',
                      display: 'flex',
                      flexDirection: 'column',
                    }}
                  >
                    <FieldArray
                      name="scoreCards"
                      render={(arrayHelpers) =>
                        formik?.values?.scoreCards?.map((item, index) => (
                          <ScoreCardContainer
                            key={index}
                            item={item}
                            formik={formik}
                            index={index}
                            arrayHelpers={arrayHelpers}
                          />
                        ))
                      }
                    />
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          </Flex>
          <FormikOnChangeObserver onChange={observFunc} delay={0} />
          <Box mt={'5px'}>
            <Feedback />
          </Box>
          <Box mt={'15px'}>
            <OverallEvaluation />
          </Box>
        </Form>
      )}
    </Formik>
  );
};
